import { render, staticRenderFns } from "./LoginRecord.vue?vue&type=template&id=25c20ad8&scoped=true&"
import script from "./LoginRecord.vue?vue&type=script&lang=js&"
export * from "./LoginRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c20ad8",
  null
  
)

export default component.exports